import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {black, white} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    paddingVertical: 2,
    paddingHorizontal: indent * 0.6,
    borderRadius: indent * 0.4,
    height: 34,
    borderColor: alto,
    backgroundColor: white,
  },
  containerReport: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    flex: 1,
    flexShrink: 1,
    minWidth: 0,
    paddingVertical: 2,
    paddingHorizontal: indent * 0.8,
    borderRadius: indent * 0.4,
    height: 34,
    borderColor: alto,
    backgroundColor: white,
  },
  text: {
    fontWeight: '600',
    marginLeft: indent * 0.4,
    fontSize: 14,
    maxWidth: 150,
  },
  textReport: {
    marginLeft: indent * 0.4,
    fontSize: 12,
    maxWidth: 150,
    color: black,
  },
  icon: {
    fontSize: 14,
    width: 16,
    paddingVertical: 1,
    height: 16,
  },
  iconReport: {
    fontSize: 16,
    width: 18,
    height: 18,
    paddingVertical: 0,
    alignSelf: 'center',
    paddingTop: 8,
  },
  loading: {
    opacity: 0.5,
  },
});
